/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

@file:Suppress("MagicNumber")

package systems.frictionless.impulse.browser.style.constants

import org.jetbrains.compose.web.css.px
import systems.frictionless.impulse.browser.style.support.FontWeight

val fontFamily = arrayOf("Nunito Sans", "sans-serif")
val fontFamilyHeaders = arrayOf("Montserrat", "sans-serif")

val fontWeightSemiBold = FontWeight.Number(600)

/* There is initialization order bug/feature in Kotlin/JS compiler.
 *
 * See discussion at https://kotlinlang.slack.com/archives/C01F2HV7868/p1636967479130600
 * Also see https://youtrack.jetbrains.com/issue/KT-25796
 *
 * `inline get` is workaround solving this issue.
 */

val inputBorderWidth
    inline get() = 1.px
val navigationListMarginLeft
    inline get() = 8.px
val navigationLogoPaddingLeft
    inline get() = grid12
val progressBarHorizontalPadding
    inline get() = grid24
val progressBarVerticalPadding
    inline get() = grid24
val progressBarBottomPadding
    inline get() = grid4
val progressBarInnerPadding
    inline get() = grid4
val checkMarkHeight
    inline get() = grid6

val tabSelectorBorderRadius
    inline get() = grid2

val DESKTOP
    inline get() = 1200.px

val MOBILE_LANDSCAPE_MAX_HEIGHT
    inline get() = 577.px
